export default __webpack_public_path__ + "static/media/share-printrest-icon.cf019733.png";